<div class="page">
  <h1 class="page__heading">MDE/PRAC Waitlist</h1>
  <h2 class="page__subheading" *ngIf="type !== 'MDE'">Preschool</h2>
  <h2 *ngIf="type === 'MDE' && getAgencyDetails">
    {{ getAgencyDetails?.siteLocation }}
  </h2>

  <br />

  <kendo-card class="container" *ngIf="type === 'MDE'">
    <div class="k-d-flex k-justify-content-between">
      <h3 class="section__heading">
        Evaluation Site Waitlist ({{
        gridView?.total > 0 ? gridView?.total : 0
        }})
      </h3>

      <button (click)="openNewReferralModalHandler()" class="btn-style" kendoButton themeColor="primary">
        <span>
          <fa-icon icon="plus" class="fa-md k-pr-2 icon-color k-align-self-center"></fa-icon></span>
        Add Student to Waitlist
      </button>
    </div>

    <div>
      <div class="loading-container">
        <kendo-loader *ngIf="loadSpinner" type="converging-spinner" size="large"></kendo-loader>
      </div>
      <kendo-grid [data]="gridView"
        [selectable]="{ mode: 'multiple', drag: true }"
        kendoGridSelectBy="studentSk" 
        [(selectedKeys)]="mySelection" 
        [sortable]="true"
        [groupable]="false" 
        [reorderable]="false" 
        [resizable]="false" 
        [navigable]="false"
        (selectionChange)="onSelectionChange($event)"
        (pageChange)="onPageChange($event)"
        [skip]="mdeSkip"
        [pageSize]="mdePageSize"
        [pageable]="{
          buttonCount: buttonCount,
          info: info,
          type: types,
          pageSizes: pageSizes,
          previousNext: previousNext,
          position: position
        }">
        <ng-template kendoGridToolbarTemplate>
          <div class="toolbar-container">
            <div>
              <form [formGroup]="mdeWaitListForm">
                <kendo-label labelCssClass="hidden-label" text="Search Student Name or ID"
                  [for]="studentSearch"></kendo-label>
                <kendo-textbox [style.width.px]="298" formControlName="mdeWaitListSearch"
                  placeholder="Search Student Name or ID"  #studentSearch
                  appNoSpecialChars>
                </kendo-textbox>
                <kendo-svg-icon [icon]="searchIcon" class="icon-style" size="medium"
                  themeColor="primary"></kendo-svg-icon>
              </form>
            </div>

            <div class="margin-style assign-button-container">
              <span class="k-mr-4 color-secondary text-bold">{{
                mySelection?.length > 0 ? mySelection?.length : 0
                }}
                Selected</span>
              <button *ngIf="mySelection?.length > 0" kendoButton themeColor="primary" class="k-mx-2"
                (click)="addWaitList()">
                Add to Worklist
              </button>
              <button *ngIf="mySelection?.length > 0" kendoButton themeColor="error" (click)="removeWaitList()">
                Release from Waitlist
              </button>
            </div>
          </div>

          <kendo-grid-spacer></kendo-grid-spacer>
        </ng-template>

        <kendo-grid-checkbox-column [width]="25" headerClass="action-column" [class]="{ 'text-center': true }"
          [resizable]="false" [columnMenu]="false" [showSelectAll]="true"
          title="Checkbox column"></kendo-grid-checkbox-column>

        <kendo-grid-column field="gridData" title="Student" [width]="220">
          <ng-template kendoGridCellTemplate let-data>
            <div class="col subsection !k-pt-0">
              <h4 class="primary-color subsection__heading !k-mt-0">
                {{ data?.firstName }} {{ data?.lastName }}
                <span *ngIf="data?.waitListNumber > 0">({{ data?.waitListNumber }})
                </span>
              </h4>
              <p class="secondary-color">
                Student ID: {{ data?.nycId }}
                <span *ngIf="data?.birthDate"> | DOB:</span>
                {{ data?.birthDate | date : "MM/dd/yyyy" }}
                <span *ngIf="data?.homeDistrict"> | Home District:</span>
                {{ data?.homeDistrict }}
              </p>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="gridData" title="Parent/Guardian Information" [width]="220">
          <ng-template kendoGridCellTemplate let-data>
            <div class="col subsection !k-pt-0">
              <h4 class="subsection__heading !k-mt-0">
                {{ data?.parentName }}
              </h4>
              <p class="secondary-color">
                {{ data?.parentContact }}
                <span *ngIf="data?.parentEmail"> | </span>
                {{ data?.parentEmail }}
              </p>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="availability" title="Parent/Guardian Availability
                " [width]="220"></kendo-grid-column>
      </kendo-grid>
    </div>
  </kendo-card>

  <kendo-card class="container section" *ngIf="type === 'CPSE'">
    <h3 class="section__heading">
      Global Worklist ({{
      globalGridView?.total > 0 ? globalGridView?.total : 0
      }})
    </h3>

    <div>
      <div class="loading-container">
        <kendo-loader *ngIf="loadSpinner" type="converging-spinner" size="large"></kendo-loader>
      </div>
      <kendo-grid [data]="globalGridView" 
        kendoGridSelectBy="studentSk" 
        [navigable]="false"
        (selectionChange)="onGobalWaitListSelectionChange($event)" 
        [(selectedKeys)]="globalMySelection" 
        [sortable]="true" 
        [groupable]="false" 
        [reorderable]="false" 
        [resizable]="false"
        [selectable]="{ mode: 'multiple', drag: true }"
        (pageChange)="onGlobalPageChange($event)"
        [skip]="globalSkip"
        [pageSize]="globalPageSize"
        [pageable]="{
          buttonCount: buttonCount,
          info: info,
          type: types,
          pageSizes: pageSizes,
          previousNext: previousNext,
          position: position
        }">
        <ng-template kendoGridToolbarTemplate>
          <div class="toolbar-container">
            <div>
              <form [formGroup]="globalForm">
                <kendo-label class="hidden-label" text="Search Student Name or ID" [for]="studentSearch"></kendo-label>
                <kendo-textbox [style.width.px]="298" placeholder="Search Student Name or ID"
                  formControlName="globalSearch" #studentSearch
                  appNoSpecialChars>
                </kendo-textbox>
                <kendo-svg-icon [icon]="searchIcon" class="icon-style" size="medium"
                  themeColor="primary"></kendo-svg-icon>
              </form>
            </div>
            <div class="margin-style assign-button-container" *ngIf="hasAssignAgencyPermission">
              <span class="k-mr-4 color-secondary text-bold">{{
                globalMySelection?.length > 0 ? globalMySelection?.length : 0
                }}
                Selected</span>
              <button kendoButton themeColor="primary" [disabled]="globalMySelection?.length === 0"
                (click)="openShowAssignStudentToAgencies()" kendoGridToolbarFocusable>
                Assign to Agency
              </button>
            </div>
          </div>
        </ng-template>

        <kendo-grid-checkbox-column [width]="25" headerClass="action-column" [class]="{ 'text-center': true }"
          [resizable]="false" [columnMenu]="false" [showSelectAll]="true"
          title="Checkbox column"></kendo-grid-checkbox-column>

        <kendo-grid-column field="globalGridData" title="Student" [width]="220">
          <ng-template kendoGridCellTemplate let-data>
            <div class="col subsection !k-pt-0">
              <h4 class="subsection__heading primary-color !k-mt-0">
                {{ data?.firstName }} {{ data?.lastName }}
              </h4>
              <p class="secondary-color">
                Student ID: {{ data?.nycid }}
                <span *ngIf="data?.birthDate"> | DOB:</span>
                {{ data?.birthDate | date : "MM/dd/yyyy" }}
                <span *ngIf="data?.homeDistrict"> | Home District:</span>
                {{ data?.homeDistrict }}
              </p>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="globalGridData" title="Parent/Guardian Information" [width]="220">
          <ng-template kendoGridCellTemplate let-data>
            <div class="col subsection !k-pt-0">
              <h4 class="subsection__heading !k-mt-0">
                {{ data?.parentName }}
              </h4>
              <p class="secondary-color">
                {{ formatPhoneNumber(data?.parentContact)
                }}<span *ngIf="data?.parentEmail && data?.parentContact">
                  |
                </span>
                {{ data?.parentEmail }}
              </p>
            </div>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="availability" title="Parent/Guardian Availability" [width]="220"></kendo-grid-column>
      </kendo-grid>
    </div>
  </kendo-card>

  <app-waitlist-student [showSearchModal]="(showNewReferralModal$ | async)!" [agencySk]="agencyId"
    (closeModal)="closeModalHandler()">
  </app-waitlist-student>

  <app-assign-student-to-agencies [showAssignStudentAgency]="(showAssignStudentToAgencies$ | async)!" *ngIf="(showAssignStudentToAgencies$ | async)"
    [globalMySelection]="globalMySelection" [agencySk]="agencyId"
    (closeModal)="closeAssignStudentToAgencieseModalHandler()" [selectedAgency]="selectedAgency">
  </app-assign-student-to-agencies>
</div>